import React from "react";
import { Box, Button } from "@mui/material";

const ConflictActions = ({ onBack, onProceed, disableProceed }) => (
  <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
    <Button variant="outlined" onClick={onBack}>
      Back to Collection
    </Button>
    <Button variant="contained" color="primary" disabled={disableProceed} onClick={onProceed}>
      Proceed to Push Database
    </Button>
  </Box>
);

export default ConflictActions;
